import {ApiClient} from '@hconnect/apiclient'
import {useUpmPlantContext} from '@hconnect/upm'
import {useQuery} from '@tanstack/react-query'

export enum PlannerFeature {
  Stock = 'stock_screen',
  PriceForecast = 'price_forecast_screen',
  DemandForecast = 'demand_forecast_screen',
  Planning = 'planning_screen',
  Optimizer = 'optimizer_screen',
  ElectricityPurchasing = 'electricity_purchasing',
  ControlOperatorScreen = 'control_room_operator_view',
  PlanningComments = 'planning_comments',
  OperatorViewExactElectricityPrices = 'operator_view_exact_electricity_prices',
  OperatorViewColorCodedElectricityPrices = 'operator_view_color_coded_electricity_prices',
  ShutdownAvailability = 'shutdown_availability',
  CostAvoidance = 'cost_avoidance',
  RawMaterialsPlanning = 'raw_materials_planning',
  ThreeShippingTypes = 'three_shipping_types',
  OptimizerStatusDisplay = 'optimizer_status_display',
  OptimizerPlanAnalysis = 'optimizer_plan_analysis'
}

interface PlantConfigData {
  available_features: PlannerFeature[]
}

const usePlantConfigQuery = () => {
  const {plantId: plantCode} = useUpmPlantContext()

  return useQuery<PlantConfigData>({
    queryKey: ['plantConfig', plantCode],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<PlantConfigData>(
        `/hcem/ui/v2/config/${plantCode}`,
        {signal}
      )
      return response.data
    },
    enabled: Boolean(plantCode)
  })
}

/**
 * @deprecated Remove after planner features are exported to ConfigCat.
 */
export const usePlannerFeature = (feature: PlannerFeature): boolean => {
  const {data: plantConfig} = usePlantConfigQuery()
  const availableFeatures = plantConfig?.available_features ?? []

  return availableFeatures.includes(feature)
}
